export const LEGS = [
  {
    name: 'Torva Platelegs',
    slot: 'legs',
    regions: ['Asgarnia'],
    requirements: [{ skill: 'Defence', level: 80 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -24, ranged: -11 },
      defence: { stab: 87, slash: 78, crush: 79, magic: -9, ranged: 102 },
      other:   { meleeStrength: 4, rangedStrength: 0, magicDamage: 0, prayer: 1 },
    },
  },
  {
    name: 'Justiciar Legguards',
    slot: 'legs',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -31, ranged: -17 },
      defence: { stab: 95, slash: 92, crush: 93, magic: -14, ranged: 102 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 4 },
    },
  },
  {
    name: 'Virtus Robe Bottom',
    slot: 'legs',
    regions: ['Varlamore', 'Asgarnia', 'Fremennik', 'Desert'],
    requirements: [{ skill: 'Magic', level: 80 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 26, ranged: -9 },
      defence: { stab: 31, slash: 28, crush: 34, magic: 22, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 2, prayer: 1 },
    },
  },
  {
    name: 'Masori Chaps (f)',
    slot: 'legs',
    regions: ['Desert', 'Asgarnia'],
    requireAllRegions: true,
    requirements: [{ skill: 'Ranged', level: 80 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -2, ranged: 27 },
      defence: { stab: 35, slash: 30, crush: 39, magic: 46, ranged: 37 },
      other:   { meleeStrength: 0, rangedStrength: 2, magicDamage: 0, prayer: 1 },
    },
  },
  {
    name: 'Ancestral Robe Bottom',
    slot: 'legs',
    regions: ['Kourend'],
    requirements: [{ skill: 'Magic', level: 75 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 26, ranged: -7 },
      defence: { stab: 27, slash: 24, crush: 30, magic: 20, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 3, prayer: 0 },
    },
  },
  {
    name: 'Bandos Tassets',
    slot: 'legs',
    regions: ['Asgarnia'],
    requirements: [{ skill: 'Defence', level: 65 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -21, ranged: -7 },
      defence: { stab: 71, slash: 63, crush: 66, magic: -4, ranged: 93 },
      other:   { meleeStrength: 2, rangedStrength: 0, magicDamage: 0, prayer: 1 },
    },
  },
  {
    name: "Inquisitor's Plateskirt",
    slot: 'legs',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 60 }],
    bonuses: {
      attack:  { stab: -3, slash: -3, crush: 12, magic: -9, ranged: -5 },
      defence: { stab: 42, slash: 30, crush: 49, magic: 0, ranged: 22 },
      other:   { meleeStrength: 2, rangedStrength: 0, magicDamage: 0, prayer: 2 },
    },
  },
  {
    name: "Dharok's Platelegs",
    slot: 'legs',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 85, slash: 82, crush: 83, magic: 0, ranged: 92 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Dragon Platelegs',
    slot: 'legs',
    regions: [],
    requirements: [{ skill: 'Defence', level: 60 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -21, ranged: -11 },
      defence: { stab: 68, slash: 66, crush: 63, magic: -4, ranged: 65 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Crystal Legs',
    slot: 'legs',
    regions: ['Tirannwn'],
    requirements: [{ skill: 'Ranged', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 18 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 34, ranged: 38 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: "Black D'hide Chaps",
    slot: 'legs',
    regions: [],
    requirements: [{ skill: 'Ranged', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -10, ranged: 17 },
      defence: { stab: 18, slash: 20, crush: 26, magic: 23, ranged: 26 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Elite Void Robe',
    slot: 'legs',
    regions: ['Asgarnia', 'Tirannwn', 'Kandarin'],
    requireAllRegions: true,
    requirements: [{ skill: 'Attack', level: 40 }, { skill: 'Defence', level: 40 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 30, slash: 30, crush: 30, magic: 30, ranged: 30 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 3 },
    },
    sets: ['elite_void_mage', 'elite_void_range', 'elite_void_melee'],
  },
  // ── Barrows legs (Morytania) ───────────────────────────────────────────────
  {
    name: "Karil's Leatherskirt",
    slot: 'legs',
    regions: ['Morytania'],
    requirements: [{ skill: 'Ranged', level: 70 }, { skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -10, ranged: 17 },
      defence: { stab: 26, slash: 20, crush: 28, magic: 35, ranged: 33 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: "Ahrim's Robeskirt",
    slot: 'legs',
    regions: ['Morytania'],
    requirements: [{ skill: 'Magic', level: 70 }, { skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 22, ranged: -7 },
      defence: { stab: 33, slash: 30, crush: 36, magic: 22, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 1, prayer: 0 },
    },
  },
  {
    name: "Verac's Plateskirt",
    slot: 'legs',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -21, ranged: -11 },
      defence: { stab: 85, slash: 82, crush: 83, magic: 0, ranged: 84 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 4 },
    },
  },
  {
    name: "Torag's Platelegs",
    slot: 'legs',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -21, ranged: -11 },
      defence: { stab: 85, slash: 82, crush: 83, magic: -4, ranged: 92 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: "Guthan's Chainskirt",
    slot: 'legs',
    regions: ['Morytania'],
    requirements: [{ skill: 'Defence', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -14, ranged: -11 },
      defence: { stab: 75, slash: 72, crush: 73, magic: -4, ranged: 82 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  // ── Other region legs ──────────────────────────────────────────────────────
  {
    name: 'Masori Chaps',
    slot: 'legs',
    regions: ['Desert'],
    requirements: [{ skill: 'Ranged', level: 80 }, { skill: 'Defence', level: 30 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -2, ranged: 27 },
      defence: { stab: 26, slash: 24, crush: 29, magic: 19, ranged: 22 },
      other:   { meleeStrength: 0, rangedStrength: 2, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Granite Legs',
    slot: 'legs',
    regions: ['Fremennik'],
    requirements: [{ skill: 'Defence', level: 50 }, { skill: 'Strength', level: 50 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -31, ranged: -18 },
      defence: { stab: 43, slash: 45, crush: 41, magic: -4, ranged: 68 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Infinity Bottoms',
    slot: 'legs',
    regions: [],
    requirements: [{ skill: 'Magic', level: 50 }, { skill: 'Defence', level: 25 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 17, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 0, magic: 17, ranged: 0 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 1, prayer: 0 },
    },
  },
  {
    name: 'Obsidian Platelegs',
    slot: 'legs',
    regions: ['Karamja'],
    requirements: [{ skill: 'Defence', level: 60 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 0, ranged: 0 },
      defence: { stab: 46, slash: 43, crush: 41, magic: -10, ranged: 40 },
      other:   { meleeStrength: 1, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Blue Moon Tassets',
    slot: 'legs',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Magic', level: 75 }, { skill: 'Defence', level: 50 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: 22, ranged: 0 },
      defence: { stab: 0, slash: 0, crush: 23, magic: 32, ranged: 0 },
      other:   { meleeStrength: 1, rangedStrength: 0, magicDamage: 1, prayer: 0 },
    },
  },
  {
    name: 'Blood Moon Tassets',
    slot: 'legs',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Strength', level: 75 }, { skill: 'Defence', level: 50 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -21, ranged: -7 },
      defence: { stab: 30, slash: 50, crush: 49, magic: 32, ranged: 46 },
      other:   { meleeStrength: 2, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Eclipse Moon Tassets',
    slot: 'legs',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Ranged', level: 75 }, { skill: 'Defence', level: 50 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -15, ranged: 17 },
      defence: { stab: 9, slash: 13, crush: 37, magic: 31, ranged: 17 },
      other:   { meleeStrength: 1, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
  {
    name: 'Hueycoatl Hide Chaps',
    slot: 'legs',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Ranged', level: 70 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -10, ranged: 17 },
      defence: { stab: 31, slash: 25, crush: 33, magic: 30, ranged: 31 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 2 },
    },
  },
  {
    name: 'Sunfire Fanatic Chausses',
    slot: 'legs',
    regions: ['Varlamore'],
    requirements: [{ skill: 'Defence', level: 40 }, { skill: 'Prayer', level: 60 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -4, ranged: -11 },
      defence: { stab: 51, slash: 49, crush: 47, magic: -4, ranged: 49 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 8 },
    },
  },
  {
    name: 'Proselyte Cuisse',
    slot: 'legs',
    regions: [],
    requirements: [{ skill: 'Defence', level: 30 }],
    bonuses: {
      attack:  { stab: 0, slash: 0, crush: 0, magic: -21, ranged: -11 },
      defence: { stab: 33, slash: 31, crush: 29, magic: -4, ranged: 31 },
      other:   { meleeStrength: 0, rangedStrength: 0, magicDamage: 0, prayer: 6 },
    },
  },
  {
    name: "Oathplate legs",
    slot: 'legs',
    regions: ['Kourend'],
    requirements: [{ skill: 'Defence', level: 78 }],
    bonuses: {
      attack:  { stab: 0, slash: 12, crush: 0, magic: -12, ranged: -14 },
      defence: { stab: 75, slash: 100, crush: 73, magic: -3, ranged: 81 },
      other:   { meleeStrength: 2, rangedStrength: 0, magicDamage: 0, prayer: 0 },
    },
  },
];
